import { t } from '@lingui/macro';
import { FaSearchPlus } from 'react-icons/fa';

import { AccessibilityOption } from './AccessibilityButton';
import useAccesibilityActions from './hooks/useAccesibilityActions';

const IncreaseSizeFont = () => {
  const { changeSizeFontPlus } = useAccesibilityActions();

  return (
    <AccessibilityOption
      name={'Aumentar texto'}
      icon={<FaSearchPlus className="h-3 w-3 fill-white" />}
      onClick={() => changeSizeFontPlus()}
    />
  );
};

export default IncreaseSizeFont;
